var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70451 14.5C3.71278 14.5 0.499966 11.3534 0.499966 7.5C0.499966 3.6466 3.71278 0.5 7.70451 0.5C11.6962 0.5 14.9091 3.6466 14.9091 7.5C14.9091 11.3534 11.6962 14.5 7.70451 14.5Z",
    fill: "#447AF7",
    stroke: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.70502,
    cy: 7.49809,
    rx: 3.25004,
    ry: 3.33868,
    transform: "rotate(90 7.70502 7.49809)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTf);
export default __webpack_public_path__ + "static/media/tf.e8d9e6ee594e1ea02cbae90e89a7fb1b.svg";
export { ForwardRef as ReactComponent };